var React = require('react');

function IcShareX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.05366 9L17.5485 20.5842L9 30H10.925L18.407 21.7539L24.4537 30H31L22.029 17.766L29.9838 9H28.0622L21.1704 16.5928L15.6034 9H9.05366ZM11.8841 10.4433H14.8924L28.1729 28.5533H25.1646L11.8841 10.4433Z","fill":"black"}));
}

IcShareX.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IcShareX;

IcShareX.default = IcShareX;
